module.exports = __webpack_public_path__ + "static/img/UploadData.f02926dd.png";